import axiosConfig from "./axiosConfig";
import { DocumentIdRecord } from "./getDocumentIds";

export interface CreateDocumentIdRequest {
  type: string;
  siteID?: string;
  key?: string;
  note?: string;
}

const postDocumentId = async (
  authToken: string,
  body: CreateDocumentIdRequest
): Promise<DocumentIdRecord> => {
  const { data } = await axiosConfig.post("/document-ids", body, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default postDocumentId;
